import {
  DailyBubbleFinishedPage,
  DailyBubbleFinishedQuery,
  DailyBubblePage,
  HighlightsQuery,
  HomePageQuery,
  HomePageQueryVariables,
  ResourceEntity,
} from '@/graphql/generated/graphql';
import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import { QUERY_DAILY_BUBBLE_FINISHED_PAGE } from '@/graphql/queries/daily/daily-bubble-finished';
import { QUERY_FETCH_LATEST_RESOURCE_BY_TYPE } from '@/graphql/queries/knowledge-hub/resource';
import { QUERY_HOME_PAGE } from '@/graphql/queries/daily/daily-bubble';

export const getPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<HomePageQuery, HomePageQueryVariables>({
      query: QUERY_HOME_PAGE,
      fetchPolicy: 'cache-first',
    }),
  );

  return {
    page: data?.dailyBubblePage?.data?.attributes as DailyBubblePage,
    error,
  };
};

export const getFinishPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<DailyBubbleFinishedQuery>({
      query: QUERY_DAILY_BUBBLE_FINISHED_PAGE,
    }),
  );

  return {
    page: data?.dailyBubbleFinishedPage?.data?.attributes as DailyBubbleFinishedPage,
    error,
  };
};

export const getLatestResourcesByType = async () => {
  const apolloClient = initializeApollo();
  const { data, error } = await requestHandler(
    apolloClient.query<HighlightsQuery>({
      query: QUERY_FETCH_LATEST_RESOURCE_BY_TYPE,
    }),
  );

  return {
    resources: data?.knowledgeHubPage?.data?.attributes?.highlights?.data as ResourceEntity[],
    error,
  };
};
